export type LogLevel = 'info' | 'warn' | 'error';

export interface LogEntry {
  timestamp: number;
  level: LogLevel;
  message: string;
  context?: any;
}

const MAX_LOGS = 1000;

export const logger = {
  info: (message: string, context?: any) => log('info', message, context),
  warn: (message: string, context?: any) => log('warn', message, context),
  error: (message: string, context?: any) => log('error', message, context),
  getLogs: (): LogEntry[] => {
    const logs = localStorage.getItem('app_logs');
    return logs ? JSON.parse(logs) : [];
  },
  clearLogs: () => {
    localStorage.removeItem('app_logs');
  }
};

function log(level: LogLevel, message: string, context?: any) {
  const entry: LogEntry = {
    timestamp: Date.now(),
    level,
    message,
    context
  };
  
  console[level](message, context || '');
  
  const logs = logger.getLogs();
  logs.push(entry);
  
  if (logs.length > MAX_LOGS) {
    logs.shift();
  }
  
  localStorage.setItem('app_logs', JSON.stringify(logs));
}
